export default [
  {
    path: '/terms-and-conditions/:competitionId',
    name: 'terms-and-conditions',
    props: route => ({
      competitionId: parseInt(route.params.competitionId, 10)
    }),
    component: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/terms-and-conditions/terms-and-conditions.vue')
  }
]
